import MediaLibraryAssetCollection from 'backbone/platform/collections/assets/media_library_asset_collection.js'
import AssetsViewOptionsView from 'backbone/platform/views/assets/assets_view_options_view.js'
import AssetsCollectionListView from 'backbone/platform/views/assets/assets_collection_list_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'
import Inflector from 'utils/platform/inflector.js'
import AssetsCollectionTileView from 'backbone/platform/views/assets/assets_collection_tile_view.js'

export default class MediaLibraryAssetsCollectionView extends Backbone.View
  initialize: (options) ->
    @dispatcher = BackboneDispatcher.get_instance()
    @_mixinViewStyle(options)
    @_fetchCollection()

    @$el.parents(".js-assets-frame").on(
      "scroll",
      _.throttle(@fetchNextAssets, 1000)
    )

  render: =>
    @$el.html @template
      optionsColumn: true

    @subviews = []

    @viewOptionsView = new AssetsViewOptionsView
      activeView: @viewStyle
    @$(".toggle-asset-view").append(@viewOptionsView.render().$el)
    @subviews.push(@viewOptionsView)

    inflector = new Inflector()

    contently.ui.setup_select2(@$el)
    @$(".asset-image-count").html("<var>"+@collection.length + "</var> " + inflector.pluralize("image"))

    @_renderCollection()

  assetChanged: ->
    @dispatcher.trigger("assetChanged")

  pickedAssets: ->
    @collection.where(selected: true)

  remove: ->
    @$el.parents(".js-assets-frame").unbind("scroll")
    @_cleanupSubviews()
    @$el.empty().off()
    @stopListening()

  _mixinViewStyle: (options) ->
    viewStyleMixin = if options.viewStyle == "list-view"
      AssetsCollectionListView.prototype
    else
      AssetsCollectionTileView.prototype

    _.extend(this, viewStyleMixin)

  _fetchCollection: ->
    if @options.collection?
      @_loadCollectionFromOptions()
    else
      @_createCollection()

  _loadCollectionFromOptions: ->
    @collection = @options.collection
    @_collectionLoaded()
    @render()

  _createCollection: ->
    @collection = new MediaLibraryAssetCollection(
      null,
      brandProfileId: @options.brandProfileId
    )
    @collection.fetch
      reset: true
      success: =>
        @_collectionLoaded()

  fetchNextAssets: (event) =>
    return if @collection.loadingAssets || @collection.allAssetsLoaded

    $scrollableParentFrame = $(event.target)
    twoThirdsHeight = ($scrollableParentFrame.height() / 3) * 2

    if $scrollableParentFrame.scrollTop() >= twoThirdsHeight
      $(".js-loading-mask").addClass("maskable").maskLoading()

      @collection.fetchNextPage(
        success: @render
        error: -> contently.flash.alert("There was an error loading your assets.")
        always: -> $(".js-loading-mask").unmaskLoading().removeClass("maskable")
      )

  _collectionLoaded: ->
    @listenTo(@collection, "sync update", @render)
    @listenTo(@collection, "sync update", @assetChanged)
    @dispatcher.trigger("collectionLoaded", @collection)

  _cleanupSubviews: ->
    if @subviews
      _.each @subviews, (subview) ->
        subview.remove()
      delete @subviews



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/media_library_assets_collection_view.js.coffee